export { default as PersonCardsBlock } from './PersonCardsBlock';
export type { PersonCardsBlockProps } from './PersonCards.types';
